import { render, staticRenderFns } from "./DiemDenAnToanUpdateSuccess.vue?vue&type=template&id=4d282b4c&scoped=true&"
import script from "./DiemDenAnToanUpdateSuccess.vue?vue&type=script&lang=js&"
export * from "./DiemDenAnToanUpdateSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DiemDenAnToanUpdateSuccess.vue?vue&type=style&index=0&id=4d282b4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d282b4c",
  null
  
)

export default component.exports